import { jsx as _jsx } from "react/jsx-runtime";
var CheckmarkCircle = function CheckmarkCircle(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "m16.296 9.605-4.569 6a1 1 0 0 1-.789.395h-.007c-.306 0-.596-.142-.786-.383l-2.433-3.108a1 1 0 1 1 1.575-1.232l1.633 2.087 3.784-4.97a1 1 0 0 1 1.591 1.211ZM12 2C6.477 2 2 6.477 2 12s4.476 10 10 10c5.522 0 10-4.477 10-10S17.523 2 12 2Z",
      fill: color
    })
  });
};
export default CheckmarkCircle;